import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHeading from "@/components/marketing/SectionHeading";

const FAQS = [
  { q: "How much does Gulf newswire distribution cost?", a: "The Gulf newswire is a fixed $475, shown before you order. There are no retainers or hidden fees." },
  { q: "How much coverage will my release get?", a: "Your release delivers 80 media pickups across the Gulf, 40 in English and 40 in Arabic, including guaranteed placement on Zawya, MENA FN, and Business Arabia. Your coverage reports list every live link." },
  { q: "Which countries does the Gulf newswire cover?", a: "The United Arab Emirates, Saudi Arabia, Qatar, Kuwait, Bahrain, and Oman." },
  { q: "Is Arabic translation included?", a: "Yes. Native Arabic translation is included, and you can review the translation before it distributes." },
  { q: "How fast is distribution?", a: "Submission is same day, and distribution typically begins within 30 minutes once your release is approved and ready." },
  { q: "What reporting do I get?", a: "Two coverage reports: one at 2 days and a final report at 10 days, with live links to your published story." },
];

export default function GulfNewswireFAQ() {
  return (
    <section className="py-7 sm:py-9 lg:py-12 bg-canvas">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading tag="FAQ" title="Frequently Asked Questions" />
        <Accordion type="single" collapsible>
          {FAQS.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-border">
              <AccordionTrigger className="text-bone hover:text-cobalt text-left font-heading text-base py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-steel text-sm leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}